import triggerPopup from "../components/_trigger-popup";
import responsiveVideo from "../components/_responsive-video";
import toggleVideoModal from "../components/_toggle-video-modal";
import { utl_ehCarouselItems } from "../base/_utils";

responsiveVideo();
// toggleVideoModal("vimeo");
utl_ehCarouselItems(document.querySelector("#carouselStudentAthleteStories"));

// To change the modal, swap the id below
triggerPopup("#cta-popup");

// Stop popup video when modal is closed
const videoModals = document.querySelectorAll(".video-modal");

videoModals.forEach((videoModal) => {
    let iframe = videoModal.querySelector("iframe"); // Select iframe within current modal

    videoModal.addEventListener("hide.bs.modal", () => {
        iframe.contentWindow.postMessage('{"method":"pause"}', "https://player.vimeo.com");
    });
});
